import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyRegionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MyRegionQuery = { __typename?: 'Query', myRegion?: { __typename?: 'MyRegion', countryCode?: string | null, region: string } | null };


export const MyRegionDocument = gql`
    query myRegion {
  myRegion {
    countryCode
    region
  }
}
    `;

/**
 * __useMyRegionQuery__
 *
 * To run a query within a React component, call `useMyRegionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyRegionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyRegionQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyRegionQuery(baseOptions?: Apollo.QueryHookOptions<MyRegionQuery, MyRegionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyRegionQuery, MyRegionQueryVariables>(MyRegionDocument, options);
      }
export function useMyRegionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyRegionQuery, MyRegionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyRegionQuery, MyRegionQueryVariables>(MyRegionDocument, options);
        }
export type MyRegionQueryHookResult = ReturnType<typeof useMyRegionQuery>;
export type MyRegionLazyQueryHookResult = ReturnType<typeof useMyRegionLazyQuery>;
export type MyRegionQueryResult = Apollo.QueryResult<MyRegionQuery, MyRegionQueryVariables>;